import React  from "react";
import Header from "../components/header";
function Instructions() {


  return (
    <>
    <Header/>
      <div style = {{paddingTop:"70px", paddingLeft:"20px"}}>
      
       <h1>Instructions!</h1>
       
      </div>

    </>
  );
}

export default Instructions;
